/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type MeetingStatus = typeof MeetingStatus[keyof typeof MeetingStatus];


export const MeetingStatus = {
  concept: 'concept',
  open: 'open',
  open_for_students: 'open_for_students',
  closed_modify: 'closed_modify',
  closed_no_modify: 'closed_no_modify',
  archived: 'archived',
} as const;
